export const getEmbedUrl = (videoUrl: string): string | null => {
  if (!videoUrl) return null;

  const youtubeRegex =
    /(?:https:\/\/www\.youtube\.com\/watch\?v=|https:\/\/youtu.be\/)([\w-]+)/;
  const youtubeMatch = youtubeRegex.exec(videoUrl);
  if (youtubeMatch) {
    return `https://www.youtube-nocookie.com/embed/${youtubeMatch[1]}`;
  }

  const vimeoRegex =
    /(?:https:\/\/vimeo\.com\/|https:\/\/player\.vimeo\.com\/video\/)(\d+)/;
  const vimeoMatch = vimeoRegex.exec(videoUrl);
  if (vimeoMatch) {
    return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
  }

  return null;
};
